module.exports = __webpack_public_path__ + "static/media/inf_spe_ppe.9835c8ba.png";